import { useState } from 'react';

export interface FaqItem {
  q: string;
  a: string;
}

export default function FaqList({ items, idPrefix }: { items: FaqItem[]; idPrefix: string }) {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <div className="border-t border-background-200">
      {items.map((item, i) => {
        const isOpen = open === i;
        const panelId = `${idPrefix}-panel-${i}`;
        return (
          <div key={item.q} className="border-b border-background-200">
            <h3>
              <button
                type="button"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpen(isOpen ? null : i)}
                className="w-full flex items-center justify-between gap-6 py-6 text-left cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-500"
              >
                <span className="text-[17px] md:text-[19px] font-medium">{item.q}</span>
                <span className={`w-9 h-9 shrink-0 rounded-full border border-background-300 flex items-center justify-center transition-transform duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] ${isOpen ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-lg" />
                </span>
              </button>
            </h3>
            <div id={panelId} role="region" className={`grid transition-[grid-template-rows,opacity] duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
              <div className="overflow-hidden">
                <p className="pb-6 pr-12 text-[16px] leading-relaxed text-foreground-700 max-w-2xl">{item.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}